import React, { useEffect } from "react";
import styled from "styled-components";
import { breakpoints } from "../../utils/styles";
import { AnalyticsPromos } from "../../utils/analytics";

const Container = styled.div<{ bgColor?: string }>`
    background-color: ${props => props.bgColor || 'transparent'};
    box-sizing: border-box;
    height: 75vh;
    position: relative;
    width: 100%;

    & > div {
        height: 100%;
        padding: 0 var(--pad-x);
    }

    @media screen and (min-width: ${breakpoints.tablet}px) {
        height: 60vh;

        & > div {    
            padding-left: 5rem;
            padding-right: 5rem;
        }
    }
`;

const Image = styled.img<{ mobile?: boolean }>`
    display: ${props => (props.mobile ? 'block' : 'none')};
    height: auto;
    left: 50%;
    max-height: 70%;
    max-width: 90%;
    object-fit: contain;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -45%);
    width: 100%;

    @media screen and (min-width: ${breakpoints.tablet}px) {
        display: ${props => (props.mobile ? 'none' : 'block')};
    }
`;

function FeaturedMoviesPromo({ promo, isCurrent }: { promo: any; isCurrent?: boolean }) {
    const divRef = React.useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (isCurrent) {
            AnalyticsPromos.trackView('featured_movies_promo', promo.id, promo.title, divRef.current);
        }
    }, [isCurrent]);

    function onPromoClick(event: React.MouseEvent<HTMLAnchorElement>) {
        const openInNewWindow = promo.target !== '_self' || event.altKey || event.ctrlKey || event.shiftKey;
        AnalyticsPromos.trackClick('featured_movies_promo', promo.id, promo.title, openInNewWindow ? null : () => {
            document.location = promo.url;
        });
        if (!openInNewWindow) event.preventDefault();
    }

    return (
        <Container bgColor={promo.background_color}>
            <div ref={divRef}>
                <a href={promo.url || '#'} target={promo.target} rel="noopener noreferrer" onClick={onPromoClick}>
                    <Image src={promo.image_web_url} alt={promo.title} />
                    <Image src={promo.image_app_url} alt={promo.title} mobile />
                </a>
            </div>
        </Container>
    );
}

export default FeaturedMoviesPromo;